import Cookies from '../utils/cookies.js';

const showLoad = Cookies.get('kl_load');

// if (showLoad === 'true') {
//     document.body.classList.remove('unloaded');
//     document.body.classList.add('loaded');
// } else {
//     Cookies.set('kl_load', 'true', { expires: 14 }); // Set cookie to bypass load screen after first visit. Turned off for dev.
//     
    //CODE  USED TO GO HERE.
//}

document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
        document.body.classList.remove('unloaded');
        document.body.classList.add('loaded--stage1');
    }, 10);
    setTimeout(function () {
        document.body.classList.remove('loaded--stage1');
        document.body.classList.add('loaded--stage2');
    }, 1000);
    setTimeout(function () {
        document.body.classList.remove('loaded--stage2');
        document.body.classList.add('loaded--home');
    }, 1800);
});